export function isUSZipCode(zipCode: string, allowZipPlus4: boolean = true): boolean {
    // US ZIP codes are in the format 12345 or 12345-6789
    if (allowZipPlus4) {
        const regexZipPlus4 = /^\d{5}[-]?(\d{4})?$/;
        if (regexZipPlus4.test(zipCode))
        {
            return true;
        }
    }

    // 1 to 5 digits
    const regexFiveDigits = /^\d{1,5}$/;
    if (regexFiveDigits.test(zipCode))
        return true;

    return false;
}

export function isCandianPostalCode(postalCode: string): boolean {
  // Canadian postal codes are in the format A1A 1A1
  const regex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
  return regex.test(postalCode);
}

// Format the postal code based on the value passed in
export function formatPostalCode(postalCode: string|undefined): string|undefined
{
    if (!postalCode) 
        return;

    const postalCodeWithoutDelimits = postalCode.trim().replaceAll(" ", "").replaceAll("-", "");

    if (isUSZipCode(postalCodeWithoutDelimits)) {
        if (5 == postalCodeWithoutDelimits.length)
            return postalCodeWithoutDelimits;

        if (postalCodeWithoutDelimits.length < 5){
            return postalCodeWithoutDelimits.padStart(5, '0');
        }

        if (9 == postalCodeWithoutDelimits.length) {
            return postalCodeWithoutDelimits.substring(0, 5) + '-' + postalCodeWithoutDelimits.substring(5, 9);
        }
    }

    if (isCandianPostalCode(postalCode)) {
        return (postalCodeWithoutDelimits.substring(0, 3) + ' ' + postalCodeWithoutDelimits.substring(3, 6)).toUpperCase();
    }

    // Can't format the postal code
    return postalCode;
}